import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { ConstantsService } from '../../common/constants.service';
import { TokenService } from './token.service';

@Injectable({
    providedIn: 'root'
})
export class UserAuthService implements OnDestroy {
    private permissions: string[] = [];
    private permissionsUpdatedSubscription:Subscription;
    private isInitalLoadComplete: BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
    isInitalLoadComplete$= this.isInitalLoadComplete.asObservable();
    permissionUpdated: Subject<void> = new Subject<void>();
    constructor(private constantsService: ConstantsService, private tokenService: TokenService) {
        this.permissionsUpdatedSubscription=this.tokenService.permissionUpdated.subscribe((token) => {
            this.getRolesAndPermissions(token);
            this.permissionUpdated.next();
        });
    }
    ngOnDestroy(): void {
        this.permissionsUpdatedSubscription.unsubscribe();
    }
    checkPermission(permission: string): boolean {
        if (this.permissions ) {
            return this.permissions.includes(this.constantsService.PERMISSION_KEYS[permission]);
        }
        return false;
    }
    private getRolesAndPermissions(token): any {
        if(token!=null){
        const decoded: any = jwt_decode(token);
        this.permissions = decoded.permissions ? decoded["permissions"] : [];
        this.isInitalLoadComplete.next(true);
        }
    }
}
